module.exports = __webpack_public_path__ + "img/pillow-xxl.8099160.webp";